import { format_currency } from '../helpers/currencies.mjs';

export const get_subscription_plans = async () => {
  try {
    let response = await fetch('/rest/stripe/subscription-plans', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    }).then((r) => r.json());
    //const resp_json = await response.json();

    return response;
  } catch (err) {
    return { error: true, errors: [err.message] };
  }
};

export const get_invoices = async () => {
  let response = await fetch('/rest/stripe/invoices', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
    .then((r) => r.json())
    .catch((e) => {
      return { error: true, errors: [e.message] };
    });

  return response;
};

export const get_charges = async () => {
  let response = await fetch('/rest/stripe/charges', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
    .then((r) => r.json())
    .catch((e) => {
      return { error: true, errors: [e.message] };
    });

  return response;
};

export const get_payment_methods = async () => {
  let response = await fetch('/rest/stripe/payment-methods', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
    .then((r) => r.json())
    .catch((e) => {
      return { error: true, errors: [e.message] };
    });

  return response;
};

export const cancel_subscription_at_end_period = async (subscription_id) => {
  const submit_form = $(`
    <form action="/rest/stripe/cancel-subscription" method="POST">
      <input type="hidden" id="subscriptionId" name="subscriptionId" value="${subscription_id}"/>
    </form>`);
  $('body').append(submit_form);
  submit_form.submit();
};

export const get_proration = async (priceId) => {
  const response = await fetch('/rest/stripe/preview-proration', {
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ priceId }),
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
  })
    .then((r) => r.json())
    .catch((e) => {
      return { error: true, errors: [e.message] };
    });
  return response;
};

export const post_checkout = (priceId, simulationId = null) => {
  const simu_input = simulationId !== null ? `<input type="hidden" id="simulationId" name="simulationId" value="${simulationId}"/>` : '';
  const submit_form = $(`
  <form action="/rest/stripe/create-checkout-session" method="POST">
    <input type="hidden" id="basicPrice" name="priceId" value="${priceId}"/>
    ${simu_input}
  </form>`);
  $('body').append(submit_form);
  submit_form.submit();
};

let expected_proration = null;

export const display_proration = async (priceId) => {
  let $content = $(`
  <section id="proration-modal" role="alertdialog" tabindex="0" aria-labelledby="prompt-heading-proration" aria-describedby="prompt-message-wrapper" class="slds-modal slds-fade-in-open slds-modal_prompt" aria-modal="true">
    <div class="slds-modal__container">
      <header class="slds-modal__header slds-theme_warning slds-theme_alert-texture">          
        <h2 class="slds-text-heading_medium" id="prompt-heading-proration">Aperçu de la facturation</h2>
      </header>
      <div class="slds-modal__content slds-p-around_medium" id="prompt-message-wrapper">
        <div id="proration-content">
          <div style="height:5rem; position: relative;">
            <div class="slds-align_absolute-center" style="height: 100%">
              <div role="status" class="slds-spinner slds-spinner_medium">
                <span class="slds-assistive-text">Loading</span>
                <div class="slds-spinner__dot-a"></div>
                <div class="slds-spinner__dot-b"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="slds-modal__footer slds-theme_default slds-hide">
        <button class="slds-button slds-button_neutral" data-action="cancel" disabled="">Refuser</button>
        <button class="slds-button slds-button_brand" data-action="validate" data-priceid="${priceId}" disabled="">Valider</button>
      </footer>
    </div>
  </section>
  <div class="slds-backdrop slds-backdrop_open"></div>`);
  $content.find('.slds-modal__footer .slds-button').on('click', (e) => {
    const action = $(e.currentTarget).data('action');
    const priceId = $(e.currentTarget).data('priceid');
    if (action === 'cancel') {
      $('#proration-modal').remove();
      $('.slds-backdrop').remove();
      return;
    }
    upgrade_subscription(priceId);
  });
  $('body').append($content);
  try {
    const proration_response = await get_proration(priceId);
    if (proration_response.error) {
      $('#proration-content')
        .empty()
        .append(
          $(`
      <div>
      Une erreur est survenue lors du calcul des proratas.
      </div>
      `)
        );
      $('#proration-modal .slds-modal__footer').removeClass('slds-hide');
      $('#proration-modal .slds-modal__footer .slds-button[data-action="cancel"]').attr('disabled', false);
      return;
    }
    expected_proration = proration_response;
    let $content = $(`
    <table class="slds-table slds-table_header-hidden slds-no-row-hover" aria-label=" Example headless table of Opportunities with no borders ">
      <thead class="slds-assistive-text">
        <tr class="slds-line-height_reset">
          <th class="" scope="col">
            <div class="slds-truncate" title="Description">Description</div>
          </th>
          <th class="" scope="col">
            <div class="slds-truncate" title="Prix">Prix</div>
          </th>
        </tr>
      </thead>
      <tbody>
      ${proration_response.lines.data
        .map((d) => {
          return `
        <tr class="slds-hint-parent">
          <th data-label="Description" scope="row">
            <div class="slds-truncate">${d.description}
            </div>
          </th>
          <td data-label="Prix">
            <div style="text-align:right; font-weight: bold;">${format_currency(d.amount / 100, d.currency)}</div>
          </td>
        </tr>`;
        })
        .join('')}
        <tr class="slds-hint-parent slds-border_top">
          <th data-label="Description" scope="row">
            <div class="slds-truncate" style="text-align:right; font-weight: bold;">Total</div>
          </th>
          <td data-label="Prix">
            <div style="text-align:right; font-weight: bold;">${format_currency(proration_response.total / 100, proration_response.currency)}</div>
          </td>
        </tr>
      </tbody>        
    </table>
    <div>
    <span class="slds-icon_container slds-icon-utility-info slds-m-right_x-small slds-no-flex slds-align-top" title="Description of icon when needed">
      <svg class="slds-icon slds-icon_small slds-icon-text-light" aria-hidden="true">
        <use xlink:href="/styles/slds/assets/icons/utility-sprite/svg/symbols.svg#info"></use>
      </svg>
    </span>
    La facturation sera immédiate après la validation.</div>`);
    $('#proration-content').empty().append($content);

    $('#proration-modal .slds-modal__footer').removeClass('slds-hide');
    $('#proration-modal .slds-modal__footer .slds-button').attr('disabled', false);
  } catch (err_proration) {
    console.error('probation error', err_proration);
  }
};

const upgrade_subscription = (priceId) => {
  const submit_form = $(`
  <form action="/rest/stripe/upgrade-subscription" method="POST">
    <input type="hidden" id="prorationDate" name="prorationDate" value="${expected_proration.subscription_proration_date}"/>
    <input type="hidden" id="newPrice" name="priceId" value="${priceId}"/>
  </form>`);
  $('body').append(submit_form);
  expected_proration = null;
  submit_form.submit();
};
